import { useRef, useState } from "react";
import UseFetch from "../components/UseFetch";
import ModalAddAgent from "./ModalAddAgent";
import ModalEditeAgent from "./ModalEditeAgent";
import { NavLink } from 'react-router-dom'
import $ from "jquery"
const Agents = () => {
    const { data: agents, isloading } = UseFetch('agents');
    const [selected, setSelected] = useState(null);
    const tableRef = useRef()
    $(tableRef.current).DataTable()
    return (
        isloading ? <div className="loader"></div> : <div className="agent">
            <div className="row justify content between align-items-center">
                <div className="col-lg-8 text-primary h3">GESTION DES AGENTS</div>
                <div className="col-lg-4 text-end">
                    <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#addAgent">Ajouter</button>
                </div>
            </div>

            {agents?.length > 0 ? <div className="table-responsive">

                <table ref={tableRef} className="table table-hover table-striped table-bordered">
                    <thead className="table-primary">
                        <tr>
                            <th>N°</th>
                            <th>PRENOMS ET NOM</th>
                            <th>ADRESSE</th>
                            <th>TELEPHONE</th>
                            <th>Email</th>
                            <th className="text-end">ACTIONS</th>
                        </tr>
                    </thead>
                    <tbody className="plage">
                        {
                            agents?.map((agent, ind) => (
                                <tr key={ind} className="tr">
                                    <td>{ind + 1}</td>
                                    <td className="critere">{agent.prenom} {agent.nom}</td>
                                    <td>{agent.adresse}</td>
                                    <td>{agent.telephone}</td>
                                    <td>{agent.email}</td>
                                    <td className="text-end">
                                        <button className="btn btn-primary m-1" data-bs-toggle="modal" data-bs-target="#editeAgent" onClick={() => setSelected(agent)}>
                                            <i className="bx bx-edit"></i>
                                        </button>
                                        <NavLink to='/compte-agent' state={{ agent }} className="btn btn-info m-1">CLients</NavLink>
                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div> : <div className="row justify-content-center p-2 fs-3 bg-danger-subtle text-danger">Aucun agent trouvé!</div>
            }
            <ModalAddAgent url='agents' />
            <ModalEditeAgent agent={selected} url='agent' />
        </div>
    );
}

export default Agents;